import { Logout } from '@mui/icons-material';
import MenuIcon from '@mui/icons-material/Menu';
import { ListItemIcon, MenuItem, Stack, styled, Tooltip } from '@mui/material';
import MuiAppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const LogoutIcon = styled(Logout)(({ theme }) => ({
  color: 'white',
}));

export default function Header2({ open, toggleDrawer }) {
  const navigate = useNavigate();

  const logoutUser = () => {
    const itemsToRemove = ['token', 'user', 'role'];
    itemsToRemove.forEach((item) => {
      localStorage.removeItem(item);
    });
    navigate('/login');
  };

  return (
    <AppBar position="absolute" open={open}>
      <Toolbar sx={{ pr: '24px' }}>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={toggleDrawer}
          sx={{
            marginRight: '36px',
            ...(open && { display: 'none' }),
          }}>
          <MenuIcon />
        </IconButton>
        <Typography
          component="h1"
          variant="h6"
          color="inherit"
          noWrap
          sx={{ flexGrow: 1 }}>
          Mama & Data
        </Typography>
        <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1 }}>
          <Tooltip title="Logout" arrow>
            <MenuItem onClick={logoutUser}>
              <ListItemIcon>
                <LogoutIcon />
              </ListItemIcon>
            </MenuItem>
          </Tooltip>
        </Stack>
      </Toolbar>
    </AppBar>
  );
}
